import { render } from "./SGKCeiling.vue?vue&type=template&id=c54785a2"
import script from "./SGKCeiling.vue?vue&type=script&lang=js"
export * from "./SGKCeiling.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__